export default __webpack_public_path__ + "static/media/R20.386f54f5.png";